module.exports = __webpack_public_path__ + "img/bfj.50dd6c13.jpg";